import GroupType, { GroupTypeOptions } from './GroupType';

export type ClientGroupTypeConfig = {
  caseManager: boolean;
  projectedDischarge: {
    enabled: boolean;
  };
  referral: boolean;
  safeReturn: boolean;
  utilizationManager: boolean;
  utilizationManagement: {
    enabled: boolean;
    planTypeClassification: {
      id: string;
      name: string;
    }[];
    aiSummary: boolean;
  };
};
export interface ClientGroupTypeOptions {
  id: string;
  clientId: string;
  groupTypeId: string;
  config: ClientGroupTypeConfig;
  groupType: Partial<GroupTypeOptions> | null;
  serviceType?: string;
}

function getDefaults(): ClientGroupTypeOptions {
  return {
    id: '',
    clientId: '',
    groupTypeId: '',
    config: {
      caseManager: false,
      projectedDischarge: {
        enabled: false,
      },
      referral: false,
      safeReturn: false,
      utilizationManagement: {
        enabled: false,
        planTypeClassification: [],
        aiSummary: false,
      },
      utilizationManager: false,
    },
    groupType: {},
    serviceType: undefined,
  };
}
/**
 * @class ClientGroupType
 * @classdesc Represents a client group type in the system
 * @property {string} id - The client group type's id
 * @property {string} clientId - The assocated client id
 * @property {string} groupTypeId - The associated group type id
 * @property {GroupType | null} groupType - The client group type's group type
 * @property {ClientGroupTypeConfig} config - The client group type's configuration
 * @property {string} serviceType - The client group type's service type ('managed' or 'provided')
 * @param {Partial<ClientGroupTypeOptions>} [options={}]
 */
export default class ClientGroupType {
  id: string;
  clientId: string;
  groupTypeId: string;
  config: ClientGroupTypeConfig;
  groupType: GroupType | null;
  serviceType?: string;

  constructor(options = {}) {
    const opts = { ...getDefaults(), ...options };
    this.id = opts.id;
    this.config = opts.config;
    this.groupType = opts.groupType ? new GroupType(opts.groupType) : null;
    this.groupTypeId = opts.groupTypeId;
    this.clientId = opts.clientId;
    this.serviceType = opts.serviceType;
  }

  get isManaged() {
    return this.serviceType === 'managed';
  }

  get isProvided() {
    return this.serviceType === 'provided';
  }
}
